import { Pipe, PipeTransform } from '@angular/core';
import { Utilities } from '@shared/utils/utilities';
import { DateTimeFormatStrings } from '@shared/enums';

@Pipe({
  name: 'localeDateTime',
  standalone: true
})
export class LocaleDateTime implements PipeTransform {
  constructor() { }
  transform(value: string): string {
    if (Utilities.isEmptyString(value)) {
      return "";
    }

    const date = new Date(value);
    return Utilities.isValidDate(date) ? Utilities.formatDate(date, DateTimeFormatStrings.FORMAT_12) : "";
  }
}
